module.exports = __webpack_public_path__ + "static/media/1-1.0ca70a67.png";